<template>
    <div class="wrapper" style="background-color:#fff;">

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">
            <div style="height:60px;"></div>
            <h4 style="margin-left:10px;">Subscription</h4><br><br>
            <div class="box">
                <div class="subscription">
                    <div>Your payment succeed</div>

                    <div class="btn btn-positive" @click="done">Done</div>

                </div>
               
            </div>
        </div>
    </div>

</template>
<style scoped>
    .subscription {
        padding: 20px;
        width: 100%;
    }

    .toolbBar {
    margin-top:20px;
    }
</style>
<script>
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';

    export default {

        components: {
            Sidebar,
            
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
            return{
                sessionId: ""
            }
           
        },
        mounted() {
            var data = sessionStorage.getItem("user");
            //console.log("session", data);
            if (data !== null) {
                this.$core.data.UserInfo = JSON.parse(data);
            }
            this.sessionId = this.$route.params.sessionid;
            this.getSession();
        },
        methods: {

            getSession() {
                this.$core.GetSession(this.sessionId).then((data) => {

                    console.log(data);
                    
                });
            },
            done: function () {
               
                this.$router.push('/Subscription/');
            }
        }
    };



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #app {
        height: 100vh;
    }

    .nav-link {
        color: white;
        width: 100%;
    }

        .nav-link.active {
        }
</style>

